
try {
    // window.swymcaleed = 0;
    // if (window.location.pathname === "/pages/search") {
        
    // }
$(".search__input.field__input").on("click", function () {
    setTimeout(function () {
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    }, 300);
});
// STEP 2: When page is shown (including back button restore)
// window.addEventListener("pageshow", function () {
//     const cameFromSearch = sessionStorage.getItem("cameFromSearch");

//     // Detect if this page load happened due to BACK/FORWARD navigation
//     const nav = performance.getEntriesByType("navigation")[0];
//     const isBack = nav && nav.type === "back_forward";

//     // Check if it's a collection page
//     const isCollection = window.location.pathname.includes("/collections/");
//     window.eventfired = window.location.pathname;
//     // Only reload when:
//     // 1) Coming from search page
//     // 2) We arrived here via browser back button
//     // 3) Current page is a collection page
//     if (cameFromSearch && isBack && isCollection) {
//         sessionStorage.removeItem("cameFromSearch");
//         window.location.reload();
//     }
// });
// window.addEventListener("popstate", function (event) {
//     const cameFromSearch = sessionStorage.getItem("cameFromSearch");
//     const isCollection = window.location.pathname.includes("/collections/");

//     // Detect BACK vs FORWARD
//     const current = history.state?.position;
//     const previous = event.state?.position;

//     const isBack = previous < current;
//     // const isForward = previous > current;  // if you ever need this

//     if (cameFromSearch && isCollection && isBack) {
//         sessionStorage.removeItem("cameFromSearch");
//         window.location.reload();
//     }
// });

// const swymScriptUrl = "https://cdn.shopify.com/extensions/019ac63c-3e98-7bd4-8e8e-e79e65ec8e7a/wishlist-shopify-app-597/assets/swym-ext-shopify.js";

    // function runWhenSwymReady() {
    //     if (window.location.pathname === "/search") {
    //         if (window.wizzyLazyAssets) {
    //             window.wizzyLazyAssets.load();
    //             window.wizzyLazyAssetUtils.isWizzyLazyLoaded = true;
    //         }
    //     }
    // }

    // let checkInterval = setInterval(() => {
    //     let swymScript = document.querySelector(`script[src="${swymScriptUrl}"]`);

    //     if (!swymScript) return;

    //     if (swymScript.readyState === "complete" || swymScript.readyState === "loaded") {
    //         clearInterval(checkInterval);
    //         runWhenSwymReady();
    //     } else {
    //         swymScript.addEventListener("load", () => {
    //             clearInterval(checkInterval);
    //             runWhenSwymReady();
    //         });
    //     }

    // }, 100);



    // CHANGES
    // window.addEventListener("load", function(){
    //     if (window.location.pathname === '/search') {
    //         if(window.wizzyLazyAssets)
    //         {
    //             window.wizzyLazyAssets.load();
    //             window.wizzyLazyAssetUtils.isWizzyLazyLoaded = true;
    //         }
    //     }
    // })

    // })
    
//     function initializeSwymWishlist() {
//     // Use global utility if available, otherwise fallback to direct initialization
//         if (window.SwymWishlistUtility && typeof window.SwymWishlistUtility.initialize === 'function') {
//             window.SwymWishlistUtility.initialize();
//         } else if (window.initializeSwymWishlist) {
//             window.initializeSwymWishlist();
//         } else {
//         // Fallback: Wait for Swym to be available
//             const initSwym = () => {
//                 if (window._swat) {
//                 // Swym v2 API
//                     if (typeof window._swat.renderCollectionPage === 'function') {
//                         window._swat.renderCollectionPage();
//                     } else if (typeof window._swat.renderWishlistButtons === 'function') {
//                         window._swat.renderWishlistButtons();
//                     }
//                 } else if (window.SwymCallbacks) {
//                 // Swym callback API
//                     window.SwymCallbacks.push(function (swat) {
//                         if (typeof swat.renderCollectionPage === 'function') {
//                             swat.renderCollectionPage();
//                         } else if (typeof swat.renderWishlistButtons === 'function') {
//                             swat.renderWishlistButtons();
//                         }
//                     });
//                 } else {
//                 // Retry if Swym not loaded yet
//                     setTimeout(initSwym, 500);
//                 }
//             };

//         // Initial delay to ensure DOM is ready
//         setTimeout(initSwym, 1000);
//     }
//   }
// window.addEventListener("popstate", function () {
//     const cameFromSearch = sessionStorage.getItem("cameFromSearch");
//     const isCollection = window.location.pathname.includes("/collections/");
//     const iSSearch = window.location.pathname.includes("/pages/search");
//     const prevPos = history.state.pos;
//     const newPos = event.state.pos;
//     const isForward = newPos > prevPos;
//     if (cameFromSearch && isCollection) {
//         sessionStorage.removeItem("cameFromSearch");
//         window.location.reload();
//     }
//     if(isForward && iSSearch)
//     {
//         window.location.reload();
//     }
// });
window.onWizzyScriptLoaded = function () {
    document.addEventListener("click", function (e) {
        const el = e.target.closest(".wizzy-autocomplete-wrapper .priceonrequestbtn");
        if (el) {
            e.preventDefault();    // stop any default behavior
            e.stopPropagation();   // THIS stops click going to parent <a>
            window.location.href = "/pages/contact-us"; // your URL
        }
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
        // payload.search.configs.general.searchEndpoint = '/search';
        window.wizzyConfig.common.isLazyInit = true;
        window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
        payload.search.configs.pagination.appendInExistingList = true;


        return payload;
    });

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {

        // window._swat.initializeActionButtons(".wizzy-search-results");
        

        return payload;
    });


    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
        // payload.search.configs.general.searchEndpoint = '/search';
        window.wizzyConfig.common.isLazyInit = true;
        window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
        payload.search.configs.pagination.appendInExistingList = true;


        return payload;
    });

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
        //  window.wizzyConfig.search.configs.general.searchEndpoint = '/search';
        //  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        // console.log(payload,"BEFORE_RENDER_RESULTS")
        // window._swat.initializeActionButtons(".wizzy-search-results");
        if(payload.response.payload){
            if(payload.response.payload.total == 0){
                payload.error = true;
                payload.response.status = 0;
            }
        }
        let prohibitedWords;
        let searchTerm = window?.wizzyConfig?.pageStore?.searchSubmitValue;
        if(searchTerm)
        {
            if (searchTerm.toLowerCase().includes("silver")) {
                prohibitedWords = true;
            }
            else
            {
                prohibitedWords = false;
            }
        }
        
        if (payload.api === "search" && payload.response && payload.response.payload.filters) {
            const filterQuery = payload.response.payload.filters.q.toLowerCase();
            if(prohibitedWords)
            {
                payload.error = true;
            }
        }

        return payload;
    });

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.EMPTY_RESULTS_RENDERED,
        function (payload) {
            // console.log(payload,"EMPTY_RESULTS_RENDERED")

            return payload;
    });

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
        function (payload) {
            // console.log(payload,"PRODUCTS_CACHED_RESULTS_RENDERED")

        // Assign the anchor element to a variable
        const sortByAnchor = document.querySelector('.wizzy-sortby-mobile');
        const handleSortByClick = function(event) {
            event.preventDefault(); // Prevent the default anchor action

            const selectElement = document.querySelector('.wizzy-common-select-selector');
            if (selectElement) {
                selectElement.click();
            }
        };

        // Check if the event is already attached by checking the class
        if (sortByAnchor && !sortByAnchor.classList.contains('event-attached')) {
            sortByAnchor.addEventListener('click', handleSortByClick);
            sortByAnchor.classList.add('event-attached'); // Add class to track that the event is attached
        }

            return payload;
    });

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
        const sellingPriceExists = data.sort.some(
                (s) => s.field === "product_wizzy-best-selling_sortOrder:float" && s.order === "asc"
                );

                if (!sellingPriceExists && data.sort[0].field === "relevance") {
                data.sort = [
                    {
                    field: "relevance", order: "asc"
                    },
                    {
                    field: "product_wizzy-best-selling_sortOrder:float", order: "asc"
                    }
                ]
                // data.sort = [{ field: "sellingPrice", order: "asc", isForParent: !1}];
            }
            sessionStorage.setItem("cameFromSearch", "1");
            const mainContent = document.querySelector("#MainContent");
            if (mainContent)
            {
                const wizzyEl = mainContent.querySelector('[id*="wizzy-shopify-collection-page-wrapper"]');
                if (wizzyEl){
                    // Get the parent section (most Shopify sections use <section>)
                    const parentSection = wizzyEl.closest('.shopify-section') || wizzyEl.parentElement;
                    if (parentSection)
                    {
                        // Hide all sibling sections except the target one
                        const siblings = parentSection.parentElement.children;

                        [...siblings].forEach(el => {
                            if (el !== parentSection) {
                                el.style.display = "none";
                            }
                        });
                    }
                } 
            }

            // Find element with ID containing 'wizzy-shopify-collection-page-wrapper'
           

        // window.wizzyConfig.search.configs.general.searchEndpoint = '/search';
        // window.SwymPageData.uri = `https://aukerajewellery.com/search?q=${data.q}`;
        // window.swymLandingURL = `https://aukerajewellery.com/search?q=${data.q}`;

        // location.reload();
        document.body.classList.add('wizzy-search');
        let header = document.querySelector('.onlyhomepagetranparent');
        if(header)
        {
            header.style.position = "unset";
            let inside_header = header.querySelector('.header');
            if(inside_header)
            {
                inside_header.style.background = "white";
            }
        }
        $("svg.icon.icon-wishlist path").css("fill" , "#123843");
    	    $("header.header.header--middle-left.header--mobile-left.page-width.header--has-menu.header--has-account").css("background" , "white");
            $("svg.icon.icon-hamburger").css("color" , "black");
          $("svg.icon.icon-account path").css("fill" , "#123843");
          $("svg.icon.icon-search path").css("fill" , "#123843");
          $("svg.icon.icon-cart-empty path").css("fill" , "#123843");
           $(".header__menu-item").css("color" , "#123843");
             $("svg.icon.icon-cart").css("color" , "black");
             $(".header__heading-logo-wrapper").css("display" , "block");
             $("img.transparentlogo").css("display" , "none");


        setTimeout(() => {
            var productModals = document.querySelectorAll("product-modal");
            productModals.forEach(function(modal) {
                modal.style.display = 'none';
            });
        }, 700);

        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "#MainContent"
        ]



        return data;
    });


    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
        // console.log("AFTER_PRODUCTS_TRANSFORMED");
        products.forEach((product) => {
            if(product.sellingPrice === "0.00")
            {
                product.priceOnRequest = true;
            }
            let attributes = product.attributes;
            if(attributes)
            {
                attributes.forEach((attr) => {
                    if(attr.id === "product_metal_purity_custom")
                    {
                        if(!product.groupId || attr.values.length == 1)
                    {
                        product.metal_purity = attr.values[0].value[0];
                        }
                        else
                        {
                            attr.values?.forEach((val) => {
                                if(val.variationId === product.groupId)
                                {
                                    product.metal_purity = val.value[0];
                                }
                            })
                        }
                    }
                    else if(attr.id === "product_metal_gross_weight_custom")
                    {
                        
                        if(!product.groupId || attr.values.length == 1)
                    {
                        product.gross_weight = attr.values[0].value[0];
                        }
                        else
                        {
                            attr.values?.forEach((val) => {
                                if(val.variationId === product.groupId)
                                {
                                    product.gross_weight = val.value[0];
                                }
                            })
                        }
                    }
                    else if(attr.id === "product_diamond_weight_custom")
                    {
                        
                        if(!product.groupId || attr.values.length == 1)
                    {
                        product.diamond_weight = attr.values[0].value[0];
                        }
                        else
                        {
                            attr.values?.forEach((val) => {
                                if(val.variationId === product.groupId)
                                {
                                    product.diamond_weight = val.value[0];
                                }
                            })
                        }
                    }
                    else if(attr.id === "product_handle")
                    {
                        product.handle = attr.values[0].value[0];
                    }
                })
            }
        })
        return products;
    });

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {
        // console.log("VIEW_RENDERED");
        if(window.wizzyConfig.common.lazyDOMConfig.isOnCategoryPage)
        {
            const mainContent = document.querySelector("#MainContent");
            if (mainContent)
            {
                const wizzyEl = mainContent.querySelector('[id*="wizzy-shopify-collection-page-wrapper"]');
                if (wizzyEl){
                    // Get the parent section (most Shopify sections use <section>)
                    const parentSection = wizzyEl.closest('.shopify-section') || wizzyEl.parentElement;
                    if (parentSection)
                    {
                        // Hide all sibling sections except the target one
                        const siblings = parentSection.parentElement.children;

                        [...siblings].forEach(el => {
                            if (el !== parentSection) {
                                el.style.display = "block";
                            }
                        });
                    }
                } 
            }
        }
        

        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        if(window.wizzyConfig.common.isOnCategoryPage)
        {
            const wizzyEl = document.getElementById("wizzy-shopify-collection-page-wrapper");
            if (wizzyEl) {
                // 1. Find closest .page-width and remove padding
                const pageWidth = wizzyEl.closest(".page-width");
                if (pageWidth) {
                    pageWidth.style.padding = "0";
                }

                // 2. Find closest .shopify-section and give background
                const shopifySection = wizzyEl.closest(".shopify-section");
                if (shopifySection) {
                    shopifySection.style.background = "#f5f5f5"; // your color
                }
            }
        }
        // if(window._swat && window._swat.injectSwymButtonOnProductGrid) {
        //     window._swat.injectSwymButtonOnProductGrid();
        // }
        // // Then: Initialize click handlers
        // setTimeout(() => {
        //     window._swat.initializeActionButtons(".wizzy-search-results");
        // }, 500);
        
        // console.log("Called view rendered");
        // const len = Object.keys(window.SwymViewProducts).length;
        // console.log("Length===>",len);

        let searchTerm = window?.wizzyConfig?.pageStore?.searchSubmitValue;
        if(searchTerm)
        {
            if (searchTerm.toLowerCase().includes("silver")) {
                document.body.classList.add("silver-query");
            }
            else
            {
                document.body.classList.remove("silver-query");
            }
        }
        // Find the <ul> element with the class 'wizzy-selected-facet-list'
        var selectedFacetList = document.querySelector(".wizzy-selected-facet-list");
        if (selectedFacetList && selectedFacetList.children.length > 0) {

            // Check if Remove All already exists
            var alreadyExists = selectedFacetList.querySelector(".wizzy-filters-clear-all.remove-all");

            if (!alreadyExists) {
                var removeAllLink = document.createElement("a");
                removeAllLink.classList.add("wizzy-filters-clear-all", "remove-all");
                removeAllLink.textContent = "Remove all";
                selectedFacetList.appendChild(removeAllLink);
            }
        }
        // document.body.classList.add("view_render");

        // Assign the anchor element to a variable
        const sortByAnchor = document.querySelector('.wizzy-sortby-mobile');
        const handleSortByClick = function(event) {
            event.preventDefault(); // Prevent the default anchor action

            const selectElement = document.querySelector('.wizzy-common-select-selector');
            if (selectElement) {
                selectElement.click();
            }
        };
        console.log("Sort by");
        // Check if the event is already attached by checking the class
        if (sortByAnchor && !sortByAnchor.classList.contains('event-attached')) {
            console.log("Inside sort anchor");
            sortByAnchor.addEventListener('click', handleSortByClick);
            sortByAnchor.classList.add('event-attached'); // Add class to track that the event is attached
        }
        // setTimeout(() => {
        //     window._swat.initializeActionButtons("#ProductGridContainer");
        // }, 2000);
        // document.body.classList.add("View_render_end");


        // Re-initialize Swym wishlist after product grid update
        // if (window.SwymWishlistUtility && typeof window.SwymWishlistUtility.initialize === 'function') {
        //     setTimeout(() => {
        //         window.SwymWishlistUtility.initialize();
        //     }, 100);
        // } else if (window.initializeSwymWishlist) {
        //     setTimeout(() => {
        //         window.initializeSwymWishlist();
        //     }, 100);
        // }
        // if (!window.initializeSwymWishlist) {
        //     window.initializeSwymWishlist = function () {
        //         if (window.SwymWishlistUtility && typeof window.SwymWishlistUtility.initialize === 'function') {
        //         window.SwymWishlistUtility.initialize();
        //         } else if (window._swat) {
        //         if (typeof window._swat.renderCollectionPage === 'function') {
        //             window._swat.renderCollectionPage();
        //         } else if (typeof window._swat.renderWishlistButtons === 'function') {
        //             window._swat.renderWishlistButtons();
        //         }
        //         }
        //     };
        // }

        return payload;
    });
    
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
        window.autocompleterenderData = data;
        if(data.payload?.products?.filters?.q?.toLowerCase().includes("silver"))
        {
            data.error = true;
            data.status = 0;
            data.payload.products.result = [];
            data.payload.categories = [];
            data.payload.brands = [];
            data.payload.others = [];
            data.payload.pages = [];
        }
        return data;
    });
     window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
        window.autocompleteData = data;
        
        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
        // console.log("VIEW_RENDERED");
        if(window.wizzyConfig.common.isOnCategoryPage)
        {
            const wizzyEl = document.getElementById("wizzy-shopify-collection-page-wrapper");
            if (wizzyEl) {
                // 1. Find closest .page-width and remove padding
                const pageWidth = wizzyEl.closest(".page-width");
                if (pageWidth) {
                    pageWidth.style.padding = "0";
                }

                // 2. Find closest .shopify-section and give background
                const shopifySection = wizzyEl.closest(".shopify-section");
                if (shopifySection) {
                    shopifySection.style.background = "#f5f5f5"; // your color
                }
            }
        }
        // if(window._swat && window._swat.injectSwymButtonOnProductGrid) {
        //     window._swat.injectSwymButtonOnProductGrid();
        // }
        // // Then: Initialize click handlers
        // setTimeout(() => {
        //     window._swat.initializeActionButtons(".wizzy-search-results");
        // }, 500);
        
        console.log("Called view rendered");
        // const len = Object.keys(window.SwymViewProducts).length;
        // console.log("Length===>",len);
        let searchTerm = window?.wizzyConfig?.pageStore?.searchSubmitValue;
        if(searchTerm)
        {
            if (searchTerm.toLowerCase().includes("silver")) {
                document.body.classList.add("silver-query");
            }
            else
            {
                document.body.classList.remove("silver-query");
            }
        }
        // Find the <ul> element with the class 'wizzy-selected-facet-list'
        var selectedFacetList = document.querySelector(".wizzy-selected-facet-list");
        if (selectedFacetList && selectedFacetList.children.length > 0) {
            var removeAllLink = document.createElement("a");
            removeAllLink.classList.add("wizzy-filters-clear-all", "remove-all");
            removeAllLink.textContent = "Remove all";
            selectedFacetList.appendChild(removeAllLink);
        }

        // Assign the anchor element to a variable
        const sortByAnchor = document.querySelector('.wizzy-sortby-mobile');
        const handleSortByClick = function(event) {
            event.preventDefault(); // Prevent the default anchor action

            const selectElement = document.querySelector('.wizzy-common-select-selector');
            if (selectElement) {
                selectElement.click();
            }
        };

        // Check if the event is already attached by checking the class
        if (sortByAnchor && !sortByAnchor.classList.contains('event-attached')) {
            sortByAnchor.addEventListener('click', handleSortByClick);
            sortByAnchor.classList.add('event-attached'); // Add class to track that the event is attached
        }
        // setTimeout(() => {
        //     window._swat.initializeActionButtons("#ProductGridContainer");
        // }, 2000);
        document.body.classList.add("View_render_end");


        // Re-initialize Swym wishlist after product grid update
        // if (window.SwymWishlistUtility && typeof window.SwymWishlistUtility.initialize === 'function') {
        //     setTimeout(() => {
        //         window.SwymWishlistUtility.initialize();
        //     }, 100);
        // } else if (window.initializeSwymWishlist) {
        //     setTimeout(() => {
        //         window.initializeSwymWishlist();
        //     }, 100);
        // }
        // if (!window.initializeSwymWishlist) {
        //     window.initializeSwymWishlist = function () {
        //         if (window.SwymWishlistUtility && typeof window.SwymWishlistUtility.initialize === 'function') {
        //         window.SwymWishlistUtility.initialize();
        //         } else if (window._swat) {
        //         if (typeof window._swat.renderCollectionPage === 'function') {
        //             window._swat.renderCollectionPage();
        //         } else if (typeof window._swat.renderWishlistButtons === 'function') {
        //             window._swat.renderWishlistButtons();
        //         }
        //         }
        //     };
        // }

        return payload;
    });

     var searchIcon = document.querySelector('.header__icon[aria-label="Search"]');
    if(searchIcon){
        searchIcon.addEventListener("click", function(event){
            var searchInput = document.querySelector("#Search-In-Modal");
            if(searchInput){
                searchInput.click();
                searchInput.focus();
            }
        })
    }
}


//////////////////////////////////////

   




///////// MUTATION OBSERVER ////////////////////////////////

function updateAutocompleteWrapperPosition() {
  const searchInput = document.querySelector('.search__input');
  const autocompleteWrapper = document.querySelector('.wizzy-body-end-wrapper .wizzy-autocomplete-wrapper');

  if (searchInput && autocompleteWrapper) {
    const searchInputRect = searchInput.getBoundingClientRect();
    const newTop = searchInputRect.top + 47;
    autocompleteWrapper.style.top = `${newTop}px`;
  }
}

// Function to handle the mutation
function handleMutation(mutationsList) {
  mutationsList.forEach(mutation => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
      const detailsElement = mutation.target;
      const isOpen = detailsElement.hasAttribute('open');
      
      if (isOpen) {
        document.body.classList.add('searchbar-opened');
        setTimeout(() => {
            updateAutocompleteWrapperPosition();
        }, 300);
      } else {
        document.body.classList.remove('searchbar-opened');
      }
    }
  });
}

// Select the details element to observe
const detailsElement = document.querySelector('.header__search details');

if (detailsElement) {
  const observer = new MutationObserver(handleMutation);
  
  observer.observe(detailsElement, {
    attributes: true,
    attributeFilter: ['open'],
  });
}





} catch (error) {
console.log(error);
    
}
